import {MANIFEST_GET_LIST} from "../axios";

export const axiosGetListMan = async (axiosPrivate, isMounted, setListMan) => {
    try {
        const response = await axiosPrivate.get(MANIFEST_GET_LIST,
            {
                headers: { 'Content-Type' : 'application/json'}
            });
        isMounted && setListMan(response.data)
    } catch (err) {
        // navigate('/auth', {state: {from: location}, replace: true})
        // logout();
        console.error(err);
    }
}